import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

import MapMarkerAnimationTop from './map/map-marker-animation-top';
import MapMarkerAnimationBottom from './map/map-marker-animation-bottom';
import MapMarkerAnimationTopRight from './map/map-marker-animation-top-right';
import MapMarkerAnimationTopLeft from './map/map-marker-animation-top-left';
import MapMarkerAnimationBottomLeft from './map/map-marker-animation-bottom-left';
import MapMarkerAnimationBottomRight from './map/map-marker-animation-bottom-right';

import MapModalComponent from './map-modal-component';

class MapMarkerComponent {
    static getMarkerHTML ( html, data ) {
        var el = document.createElement('div');
        el.className = 'c-map-marker';
        el.setAttribute("data-map-marker-type", data.type);

        var currentLayout = html.html();
        currentLayout = currentLayout.replace('{{marker-text}}', data.text);
        currentLayout = currentLayout.replace('{{marker-type}}', data.type);

        el.innerHTML = currentLayout;
        
        return el;
    }

    constructor(data, index) {
        this.index = index;
        this.render( data );
    }

    show ( delay ) {
        if( !delay ){ delay = 0; }
        this.animation.show( delay );
    }

    hide ( delay ) {
        if( !delay ){ delay = 0; }
        this.animation.hide( delay );
    }

    enable() {
        TweenMax.killTweensOf(this.element);
        TweenMax.to(this.element, 0.3, { opacity: 1 });
    }

    disable() {
        TweenMax.killTweensOf(this.element);
        TweenMax.set(this.element, { opacity: 0 });
    }

    element_CLICK ( e ) {
        $(window).trigger( MapModalComponent.EVENT.MAP_MODAL_OPEN, [ this.data ] );
    }

    element_MOUSE_ENTER(e) {
        $(this).trigger('ENTER');
        TweenMax.to(this.text, 0.6, { opacity: 1, ease: Cubic.easeOut });
    }

    element_MOUSE_LEAVE(e) {
        $(this).trigger('LEAVE');
        TweenMax.to(this.text, 0.6, { opacity: 0, ease: Cubic.easeOut });
    }

    render ( data ) {
        this.data = data;
        this.element = $(this.data.marker._element);
        this.element.css('pointer-events', 'none');

        this.height = 200;

        this.type = this.element.attr('data-map-marker-type');

        this.square = this.element.find('*[data-component="c-map-marker-square"]');
        this.pin = this.element.find('*[data-component="c-map-pin"]');
        this.circle1 = this.element.find('*[data-component="c-map-pin-circle-1"]');
        this.circle2 = this.element.find('*[data-component="c-map-pin-circle-2"]');
        this.line1 = this.element.find('*[data-component="c-map-marker-line-1"]');
        this.line2 = this.element.find('*[data-component="c-map-marker-line-2"]');
        this.text = this.element.find('*[data-component="c-map-marker-text"]');
        this.hit = this.element.find('*[data-component="c-map-pin-hit"]');

        TweenMax.set(this.text, { opacity: 0 });

        this.animation;

        switch( this.type ){
            case "top":
                this.animation = new MapMarkerAnimationTop(this);
                break;
            case "top-right":
                this.animation = new MapMarkerAnimationTopRight(this);
                break;
            case "top-left":
                this.animation = new MapMarkerAnimationTopLeft(this);
                break;
            case "bottom":
                this.animation = new MapMarkerAnimationBottom(this);
                break;
            case "bottom-left":
                this.animation = new MapMarkerAnimationBottomLeft(this);
                break;
            case "bottom-right":
                this.animation = new MapMarkerAnimationBottomRight(this);
                break;
        }
        
        TweenMax.set( this.element, { opacity: 0 } );
        this.hit.on('click', this.element_CLICK.bind(this));

        if ( !Device.instance.isTouch() ){
            this.hit.on('mouseenter', this.element_MOUSE_ENTER.bind(this));
            this.hit.on('mouseleave', this.element_MOUSE_LEAVE.bind(this));
        }
    }
}

export default MapMarkerComponent;